import { render, staticRenderFns } from "./SubFolderDocumentTypeXML.vue?vue&type=template&id=31f765fa&scoped=true&"
import script from "./SubFolderDocumentTypeXML.vue?vue&type=script&lang=js&"
export * from "./SubFolderDocumentTypeXML.vue?vue&type=script&lang=js&"
import style0 from "./SubFolderDocumentTypeXML.vue?vue&type=style&index=0&id=31f765fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f765fa",
  null
  
)

export default component.exports